export function teamMemberModal() {
    const m = document.querySelectorAll('.team-member');
    const modals = document.querySelectorAll('.team-member-modal');
    const overlay = document.querySelector('.page-overlay--modal');

    const closeAll = () => {
        modals.forEach(el => el.classList.remove('is-active'));
        document.body.classList.remove('no-scroll');
        overlay?.classList.remove('page-overlay--active');
        lenis.start(); // 🔥 resume scroll
    };

    m.forEach(el => el.addEventListener('click', e => {
        if (e.target.closest('a')) return;

        const modal = document.getElementById(el.dataset.modalId);
        if (!modal) return;

        closeAll();
        modal.classList.add('is-active');
        document.body.classList.add('no-scroll');
        overlay?.classList.add('page-overlay--active');
        lenis.stop(); // 🔥 stop scroll
    }));

    modals.forEach(modal => {
        const box = modal.querySelector('.team-member-modal__container');

        modal.querySelector('.team-member-modal__close')
            ?.addEventListener('click', closeAll);

        modal.addEventListener('click', e => {
            if (!box.contains(e.target)) closeAll();
        });
    });

    overlay?.addEventListener('click', closeAll);

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeAll();
    });
}